import { Component, Input } from '@angular/core';
import { ConfigStore } from '@app/app-configs/config-store';

@Component({
	standalone: false,
	selector: 'app-logo',
	templateUrl: './app-logo.component.html',
	styleUrls: ['./app-logo.component.scss']
})
export class AppLogoComponent{
	@Input() logoHeight:string="100%";
	public readonly brandLogo:string=ConfigStore.get('branding.logo');
}
